import React from "react";
import { connect } from "react-redux";

import { getSchoolStudentIDList } from "state/school_money/selectors";
import { goToShopItem } from "state/school_money/actions";

import Card from "components/app/home/Card";
import BulletItem from "components/app/home/BulletItem";
import Currency from "components/Currency";

class ShopItem extends React.Component {
  
  goToShopItem = () => {
    const { shopItem, studentID } = this.props;
    this.props.goToShopItem(shopItem.id, studentID)
  }
  
  render() {
    const { id, name, price } = this.props.shopItem;
    return (
      <div key={id} onClick={this.goToShopItem}>
        <Card>
          <BulletItem cssModifier="school_money">
            <div className="school_money-home-shop-items__shop-item">
              <div className="school_money-home-shop-items__name">{name}</div>
              <div className="school_money-home-shop-items__price">
                <Currency amount={price} />
              </div>
            </div>
          </BulletItem>
        </Card>
      </div>
    )
  }
  
}

/**
 * Get default studentID to go to on click.
 * First student ID for the shop item's school.
 */
export default connect(
  (state, { shopItem }) => ({
    studentID: getSchoolStudentIDList(state, shopItem.schoolID).first()
  }),
  { goToShopItem }
)(ShopItem)



// WEBPACK FOOTER //
// ./src/components/app/home/sections/school_money/ShopItem.js